import PropTypes from "prop-types";
import classnames from "classnames";

// Mirrors Nook Pay Hub's chipClass/Dot system (src/components/nook/StatusChip.tsx) exactly.
const TONE_CLASS = {
    success    : "bg-success/10 text-success border-success/20",
    warning    : "bg-warning/15 text-warning-foreground border-warning/30",
    info       : "bg-info/10 text-info border-info/20",
    destructive: "bg-danger/10 text-danger border-danger/20",
    neutral    : "bg-light text-muted border-gray-200",
    held       : "bg-held/10 text-held border-held/25"
};

const DOT_CLASS = {
    success    : "bg-success",
    warning    : "bg-warning",
    info       : "bg-info",
    destructive: "bg-danger",
    neutral    : "bg-muted/60",
    held       : "bg-held"
};

const StatusChip = ({ tone = "neutral", label, className }) => (
    <span
        title={typeof label === "string" ? label : undefined}
        className={classnames(
            "inline-flex max-w-full items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
            TONE_CLASS[tone] || TONE_CLASS.neutral,
            className
        )}>
        <span className={classnames("h-1.5 w-1.5 shrink-0 rounded-full", DOT_CLASS[tone] || DOT_CLASS.neutral)} />
        <span className="truncate">{label}</span>
    </span>
);

StatusChip.propTypes = {
    tone     : PropTypes.oneOf(["success", "warning", "info", "destructive", "neutral", "held"]),
    label    : PropTypes.node.isRequired,
    className: PropTypes.string
};

export default StatusChip;  